var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasticdressing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "download_12_",
    "data-name": "download (12)",
    transform: "translate(708.881 2509.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M249.379,467l-2.5-2.476,6.9-6.984a5.68,5.68,0,0,1,3.029-1.6l5.564-1a8.387,8.387,0,0,0,4.519-2.371l14.5-14.671a1.771,1.771,0,0,0,.517-1.291,1.793,1.793,0,0,0-.563-1.268,1.835,1.835,0,0,0-2.547.106l-2.5-2.476a5.383,5.383,0,0,1,7.465-.2,5.3,5.3,0,0,1,.153,7.594l-14.5,14.671a11.837,11.837,0,0,1-6.408,3.369l-5.564,1a2.181,2.181,0,0,0-1.15.6Z",
    transform: "translate(-48.108 -188.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M333.179,407.412l-2.5-2.476,15.376-15.564a1.8,1.8,0,0,0-.012-2.536l-.059-.058a1.8,1.8,0,0,0-1.256-.517h-.012a1.729,1.729,0,0,0-1.256.528l-2.523-2.465a5.229,5.229,0,0,1,3.744-1.572h.036a5.237,5.237,0,0,1,3.732,1.538l.059.059a5.313,5.313,0,0,1,.035,7.512Z",
    transform: "translate(-110.64 -152.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M321.529,375.523l-2.5-2.476,16.526-16.725a1.8,1.8,0,0,0-.012-2.536l-.059-.059a1.805,1.805,0,0,0-2.535.012l-5.411,5.481-2.5-2.476,5.411-5.481a5.327,5.327,0,0,1,7.512-.047l.059.059a5.313,5.313,0,0,1,.035,7.512Z",
    transform: "translate(-101.947 -127.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M272.843,371.669l-2.5-2.476,11.115-11.256a1.771,1.771,0,0,0,.517-1.291,1.793,1.793,0,0,0-.563-1.268,1.835,1.835,0,0,0-2.547.106L263.7,370.836a1.762,1.762,0,0,1-2.207.258,1.782,1.782,0,0,1-.751-2.1v-.012l4.225-11.8a1.777,1.777,0,0,0-.422-1.855,1.656,1.656,0,0,0-1.186-.5l.094-3.521a5.3,5.3,0,0,1,4.835,7.078l-1.584,4.426,9.66-9.777a5.383,5.383,0,0,1,7.465-.2,5.231,5.231,0,0,1,1.678,3.767,5.325,5.325,0,0,1-1.526,3.839Z",
    transform: "translate(-58.38 -128.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M184.909,391.1l-2.5-2.476,6.808-6.89a2.192,2.192,0,0,0,.611-1.28l.7-6.679a14.005,14.005,0,0,1,1.7-5.364l8.076-14.425a5.346,5.346,0,0,1,4.014-2.676l.4,3.5a1.744,1.744,0,0,0-1.338.892l-8.076,14.425a10.523,10.523,0,0,0-1.28,4.014l-.7,6.679a5.715,5.715,0,0,1-1.608,3.381Z",
    transform: "translate(0 -128.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M249.379,467l-2.5-2.476,6.9-6.984a5.68,5.68,0,0,1,3.029-1.6l5.564-1a8.387,8.387,0,0,0,4.519-2.371l14.5-14.671a1.771,1.771,0,0,0,.517-1.291,1.793,1.793,0,0,0-.563-1.268,1.835,1.835,0,0,0-2.547.106l-2.5-2.476a5.383,5.383,0,0,1,7.465-.2,5.3,5.3,0,0,1,.153,7.594l-14.5,14.671a11.837,11.837,0,0,1-6.408,3.369l-5.564,1a2.181,2.181,0,0,0-1.15.6Z",
    transform: "translate(-48.108 -188.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M333.179,407.412l-2.5-2.476,15.376-15.564a1.8,1.8,0,0,0-.012-2.536l-.059-.058a1.8,1.8,0,0,0-1.256-.517h-.012a1.729,1.729,0,0,0-1.256.528l-2.523-2.465a5.229,5.229,0,0,1,3.744-1.572h.036a5.237,5.237,0,0,1,3.732,1.538l.059.059a5.313,5.313,0,0,1,.035,7.512Z",
    transform: "translate(-110.64 -152.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M321.529,375.523l-2.5-2.476,16.526-16.725a1.8,1.8,0,0,0-.012-2.536l-.059-.059a1.805,1.805,0,0,0-2.535.012l-5.411,5.481-2.5-2.476,5.411-5.481a5.327,5.327,0,0,1,7.512-.047l.059.059a5.313,5.313,0,0,1,.035,7.512Z",
    transform: "translate(-101.947 -127.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M184.909,390.991l-2.5-2.476,6.808-6.89a2.192,2.192,0,0,0,.611-1.28l.7-6.679a14.005,14.005,0,0,1,1.7-5.364l8.076-14.425a5.346,5.346,0,0,1,4.014-2.676l.117-.012.563-.024h.058a5.3,5.3,0,0,1,4.835,7.078l-1.584,4.426,9.66-9.777a5.383,5.383,0,0,1,7.465-.2,5.231,5.231,0,0,1,1.678,3.767,5.325,5.325,0,0,1-1.526,3.839l-11.115,11.256-2.5-2.476,11.115-11.256a1.771,1.771,0,0,0,.517-1.291,1.793,1.793,0,0,0-.563-1.268,1.835,1.835,0,0,0-2.547.106L205.32,370.733a1.787,1.787,0,0,1-2.958-1.843v-.012l4.225-11.8a1.777,1.777,0,0,0-.422-1.855,1.675,1.675,0,0,0-1.138-.5l-.364.012a1.742,1.742,0,0,0-1.291.892L195.3,370.052a10.523,10.523,0,0,0-1.28,4.014l-.7,6.679a5.715,5.715,0,0,1-1.608,3.38Z",
    transform: "translate(0 -128.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M255.77,316.511a3.149,3.149,0,0,1-2.207-.9l-7.652-7.559,2.476-2.5,7.371,7.289,20.634-20.879-43.84-43.312-20.623,20.868,8.428,8.322-2.476,2.5-8.7-8.592a3.07,3.07,0,0,1-.927-2.207,3.125,3.125,0,0,1,.9-2.219l21.163-21.42a3.132,3.132,0,0,1,4.425-.023l44.388,43.853a3.07,3.07,0,0,1,.927,2.207,3.125,3.125,0,0,1-.9,2.219L258,315.572a3.12,3.12,0,0,1-2.23.939Z",
    transform: "translate(-19.289 -49.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M227.76,287.648l23.1-23.379,2.505,2.474-23.1,23.379Z",
    transform: "translate(-33.842 -64.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M370.85,429.048l23.1-23.379,2.505,2.474-23.1,23.379Z",
    transform: "translate(-140.617 -169.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M310.069,199.9l-2.605-2.371a67.72,67.72,0,0,1,29.754-19.05l1.057,3.357A64.173,64.173,0,0,0,310.069,199.9Z",
    transform: "translate(-93.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M469.015,240.863l-.975-3.38c1.432-.41,2.911-.774,4.378-1.057l.681,3.451c-1.362.271-2.747.6-4.085.986Z",
    transform: "translate(-213.141 -43.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M389.346,267.078l-2.43-2.547a47.975,47.975,0,0,1,10.271-7.429l1.678,3.1a44.342,44.342,0,0,0-9.519,6.877Z",
    transform: "translate(-152.605 -58.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M451.118,315.992l-2.371-2.605c4.073-3.7,9.471-6.315,16.526-8.005l.822,3.427c-6.456,1.549-11.362,3.9-14.977,7.184Z",
    transform: "translate(-198.744 -94.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M476.353,379.832,473.63,377.6a40.914,40.914,0,0,1,22.231-13.815l.8,3.427a37.246,37.246,0,0,0-20.305,12.618Z",
    transform: "translate(-217.312 -138.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M196.026,211.919h-2.864l-.317-1.361a7.214,7.214,0,0,0-5.376-5.376l-1.361-.317V202l1.373-.317a7.143,7.143,0,0,0,5.376-5.376l.317-1.373h2.864l.317,1.373a7.143,7.143,0,0,0,5.376,5.376L203.1,202v2.864l-1.373.317a7.143,7.143,0,0,0-5.376,5.376Zm-4-8.486a11,11,0,0,1,2.559,2.559,10.789,10.789,0,0,1,2.559-2.571,10.166,10.166,0,0,1-1.385-1.174,10.94,10.94,0,0,1-1.174-1.385,10.168,10.168,0,0,1-1.174,1.385A8.244,8.244,0,0,1,192.023,203.432Z",
    transform: "translate(-2.76 -12.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M523.579,519.822H520.75l-.317-1.361a2.273,2.273,0,0,0-1.69-1.69l-1.361-.317v-2.829l1.373-.317a2.242,2.242,0,0,0,1.678-1.678l.317-1.373h2.828l.317,1.373a2.337,2.337,0,0,0,.6,1.091,2.243,2.243,0,0,0,1.08.6l1.373.317v2.828l-1.373.317a2.241,2.241,0,0,0-1.678,1.678Z",
    transform: "translate(-249.96 -247.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M536.1,235.982a5.164,5.164,0,1,1,5.164-5.164A5.164,5.164,0,0,1,536.1,235.982Zm0-6.808a1.644,1.644,0,1,0,1.644,1.644A1.648,1.648,0,0,0,536.1,229.175Z",
    transform: "translate(-260.071 -35.206)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticdressing);
export default __webpack_public_path__ + "static/media/plasticdressing.afafbc04e2daba78d221a3553056fc2c.svg";
export { ForwardRef as ReactComponent };